import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { AuthProvider } from "./contexts/AuthContext";
import { WorkspaceProvider } from "./contexts/WorkspaceContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installChunkReloadHandler } from "./lib/lazy-with-retry";
import { registerServiceWorker } from "./lib/registerServiceWorker";

// Auto-recover from stale chunk loads after a deploy. Without this,
// users with cached old index.html crash with "Failed to fetch
// dynamically imported module" when they navigate to a route whose
// chunk hash no longer matches the freshly-deployed asset names.
installChunkReloadHandler();

// Register the PWA service worker (production only) so N71 can be
// installed to the home screen and launches fast.
registerServiceWorker();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <WorkspaceProvider>
          <App />
        </WorkspaceProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
